import React from 'react';
import PropTypes from 'prop-types';

const PlaceholderText = ({children}) => (
  <div className="college-earnings-empty-placeholder">
    <p className="college-earnings-empty-placeholder-description">{children}</p>
  </div>
);

PlaceholderText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
};

export default PlaceholderText;
